export default __webpack_public_path__ + "static/common-sense-ae00b86fdfb68a71e4bd194134192c76.svg";